let lastValidatedToken: string | null = null
let lastValidationResult = false

export function invalidateAuthCache() {
  lastValidatedToken = null
  lastValidationResult = false
}

export function getCachedAuthValidation(token: string): boolean | null {
  if (!token) return null
  if (token === lastValidatedToken) {
    return lastValidationResult
  }
  return null
}

export function setAuthValidationCache(token: string, valid: boolean) {
  lastValidatedToken = token
  lastValidationResult = valid
}
